interface ValidationErrorProps {
    message?: string
}

export default function ValidationError({ message }: ValidationErrorProps): JSX.Element {
    return (
        <>
            {message ? (
            <div style={{ color: "red", fontSize: 12, marginTop: 0 }}>
                {message}
            </div>)
            : <></>}
        </>
    )
}
